module.exports = __webpack_public_path__ + "static/media/infografika.f641a94a.jpg";